import React from "react";
import { Col, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//STYLES
import * as SlotStyles from "../styles/slot";

//IMAGES
import albumImage from "../../../../../public/environmentPods/photoGallery/Ablum icon.png";

function AlbumSlot(props) {
    const navigate = useNavigate();

    function handleAlbumClick(name) {
        navigate(`./album/${name}`);
    }

    return (
        <div style={SlotStyles.cardBody} onClick={handleAlbumClick.bind(this, props.title)}>
            <div style={SlotStyles.cardPicture}>
                <Image src={albumImage} style={SlotStyles.albumImage} />
            </div>
            <div style={SlotStyles.cardText}>{props.title}</div>
        </div>
    );
}

export default AlbumSlot;
